<script>export let text;
export let buttonText = "";
export let direction = "left";
export let backgroundAccent = false;
export let light = false;
export let maxWidth;
</script>

<style>.tooltip {
  display: inline-block;
  background-color: hsl(var(--color-N32)/75%);
  color: hsl(var(--color-font));
  max-width: var(--max-width);
  font-size: 10px;
  padding: 8px 8px 16px;
  box-sizing: border-box;
  position: relative;
  -webkit-mask-box-image-source: url("./bg-mask.svg");
          mask-border-source: url("./bg-mask.svg");
  -webkit-mask-box-image-slice: 20 fill;
          mask-border-slice: 20 fill;
  -webkit-mask-box-image-width: 20px;
          mask-border-width: 20px;
}
.tooltip.right {
  -webkit-mask-box-image-source: url("./bg-mask-right.svg");
          mask-border-source: url("./bg-mask-right.svg");
}
.tooltip.topRight {
  -webkit-mask-box-image-source: url("./bg-mask-top-right.svg");
          mask-border-source: url("./bg-mask-top-right.svg");
  padding: 16px 8px 8px;
}
.tooltip.topLeft {
  -webkit-mask-box-image-source: url("./bg-mask-top-left.svg");
          mask-border-source: url("./bg-mask-top-left.svg");
  padding: 12px 8px 8px;
}
.tooltip.backgroundAccent {
  background-color: hsl(var(--color-A30));
}
.tooltip.backgroundAccent.light {
  background-color: hsl(var(--color-N08));
}
.cta {
  display: flex;
  justify-content: flex-end;
}
.cta-button {
  background-color: hsl(var(--color-N12));
  text-transform: uppercase;
  color: hsl(var(--color-font));
  border: none;
  font-size: 8px;
  padding: 3px 10px 2px;
  font-weight: 600;
  cursor: pointer;
}</style>

<div
  class="tooltip"
  class:right={direction === "right"}
  class:topRight={direction === "topRight"}
  class:topLeft={direction === "topLeft"}
  class:backgroundAccent
  class:light
  style:--max-width={maxWidth ? `${maxWidth}px` : "auto"}>
  <slot>
    <span class="description">{text}</span>
  </slot>
  {#if buttonText}
    <span class="cta">
      <button class="cta-button">{buttonText}</button>
    </span>
  {/if}
</div>
